// extracted by mini-css-extract-plugin
module.exports = {"root":"TradeIn_root__19r_3","brand":"TradeIn_brand__3MjTb","model":"TradeIn_model__3eXeg","serialNo":"TradeIn_serialNo__3k1yr","action":"TradeIn_action__2F37_"};